<template>
  <div>
    <h5 class="display-5 p-2">EWallet Summary</h5>
    <div v-if="Busy == true">
      <CCol sm="12" md="12">
        <div class="app flex-row align-items-center">
          <div class="container d-flex justify-content-center">
            <PulseLoader float />
          </div>
        </div>
      </CCol>
    </div>
    <div v-else>
      <CButton type="subnit" color="success" class="mb-4">Add EWallet</CButton>
      <CCard class="m-0 mb-2" color="floralwhite">
        <CRow class="p-2 ml-3 mr-3 mt-2 mb-2">
          <CCol sm="1" lg="1"><strong> #</strong></CCol>
          <CCol sm="4" lg="4"><strong>Name</strong></CCol>
          <CCol sm="1" lg="1"><strong>Debit</strong></CCol>
          <CCol sm="1" lg="1"><strong> Credit</strong></CCol>
          <CCol sm="1" lg="1"><strong> isCheck</strong></CCol>
          <CCol sm="4" lg="4"><strong>Date</strong></CCol>
        </CRow>
      </CCard>
      <CCard v-for="(item, index) in ewallet" :key="item.Id" class="m-0 mb-2">
        <CRow class="p-2 ml-3 mr-3 mt-2 mb-2">
          <CCol sm="1" lg="1">
            <strong>{{ index + 1 }}</strong></CCol
          >
          <CCol sm="4" lg="4"
            ><span class="text-uppercase"> {{ item.Name }}</span></CCol
          >
          <CCol sm="1" lg="1"> {{ item.Debit }}</CCol>
          <CCol sm="1" lg="1"> {{ item.Credit }}</CCol>
          <CCol sm="1" lg="1"
            ><span v-if="item.isCheck===true"> <img style="width:20px" src="../assets/img/checked.png" /></span
            ><span v-else><img  style="width:20px" src="../assets/img/unchecked.png" /></span></CCol>
          <CCol sm="4" lg="4"
            ><span class="d-flex">
              {{ item.Date | moment("dddd DD MMMM YYYY, h:mm a") }}</span
            ></CCol
          >
        </CRow>
      </CCard>
    </div>
  </div>
</template>


<script>
import Vue from "vue";
Vue.use(require("vue-moment"));
import moment from "moment";

import _ from "lodash";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";

export default {
  name: "Collapses",
  components: {
    PulseLoader,
  },
  data() {
    return {
      ewallet: [],
      Busy: false,
    };
  },
  async mounted() {
    this.GetEwallet();
  },
  methods: {
    async GetEwallet() {
      this.Busy = true;
      this.$API
        .get(this.$EWalletSummary, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.Busy = false;
            this.ewallet = response.data;
          }
        });
    },
  },
};
</script>